module.exports = __webpack_public_path__ + "static/media/usdx.18b6c2dc.svg";